import { Clock } from "lucide-react";

export const DAYS = [["mon", "Mon"], ["tue", "Tue"], ["wed", "Wed"], ["thu", "Thu"], ["fri", "Fri"], ["sat", "Sat"], ["sun", "Sun"]];
export const emptyAvailability = () => ({
  available_now: true,
  schedule: Object.fromEntries(DAYS.map(([k]) => [k, { enabled: false, start: "09:00", end: "17:00" }])),
});

const timeCls = "px-3 min-h-[44px] rounded-lg border border-[#E2D9CE] focus:border-[#D96B43] outline-none font-medium";

export default function AvailabilityEditor({ value, onChange }) {
  const av = { ...emptyAvailability(), ...value, schedule: { ...emptyAvailability().schedule, ...(value?.schedule || {}) } };
  const setDay = (k, patch) => onChange({ ...av, schedule: { ...av.schedule, [k]: { ...av.schedule[k], ...patch } } });

  return (
    <div data-testid="availability-editor" className="space-y-4">
      <div className="flex items-center justify-between bg-[#FAF8F5] rounded-xl p-4">
        <div>
          <p className="font-semibold text-slate-900">{av.available_now ? "Available for new requests" : "Away — not taking requests"}</p>
          <p className="text-sm text-slate-500">Switch off when you're on holiday or busy.</p>
        </div>
        <button type="button" role="switch" aria-checked={av.available_now} data-testid="available-now-toggle"
          onClick={() => onChange({ ...av, available_now: !av.available_now })}
          className={`relative w-16 h-9 rounded-full transition-colors ${av.available_now ? "bg-[#2E7D6B]" : "bg-slate-300"}`}>
          <span className={`absolute top-1 w-7 h-7 rounded-full bg-white shadow transition-transform ${av.available_now ? "translate-x-8" : "translate-x-1"}`} />
        </button>
      </div>
      <div className="space-y-2">
        {DAYS.map(([k, label]) => {
          const d = av.schedule[k];
          return (
            <div key={k} className="flex flex-wrap items-center gap-3">
              <button type="button" data-testid={`day-toggle-${k}`} onClick={() => setDay(k, { enabled: !d.enabled })}
                className={`w-16 min-h-[44px] rounded-lg font-semibold transition-colors ${d.enabled ? "bg-[#D96B43] text-white" : "bg-white border border-[#E2D9CE] text-slate-600"}`}>
                {label}
              </button>
              {d.enabled ? (
                <div className="flex items-center gap-2 text-slate-700">
                  <Clock className="w-4 h-4 text-[#2E7D6B]" />
                  <input data-testid={`day-start-${k}`} type="time" value={d.start} onChange={(e) => setDay(k, { start: e.target.value })} className={timeCls} />
                  <span>to</span>
                  <input data-testid={`day-end-${k}`} type="time" value={d.end} onChange={(e) => setDay(k, { end: e.target.value })} className={timeCls} />
                </div>
              ) : <span className="text-slate-400 text-sm">Not available</span>}
            </div>
          );
        })}
      </div>
      <p className="text-sm text-slate-500">Leave all days off to be shown as available any time.</p>
    </div>
  );
}

export function AvailabilitySummary({ availability }) {
  const s = availability?.schedule || {};
  const on = DAYS.filter(([k]) => s[k]?.enabled);
  if (availability?.available_now === false) return <p className="text-slate-600">Currently away — not taking new requests.</p>;
  if (on.length === 0) return <p className="text-slate-600">Available any time.</p>;
  return (
    <ul data-testid="availability-summary" className="grid sm:grid-cols-2 gap-1 text-slate-700">
      {on.map(([k, label]) => <li key={k} className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#2E7D6B]" /> {label}: {s[k].start} – {s[k].end}</li>)}
    </ul>
  );
}
